export enum PaymentDeviceType {
    UNION_PAY_CARD = 'UNION_PAY_CARD',
    BANK_ACCOUNT = 'BANK_ACCOUNT',
    CREDIT_CARD = 'CREDIT_CARD',
    BPAY_WALLET = 'BPAY_WALLET',
    SKRILL = 'SKRILL',
    POLI = 'POLI',
    FASAPAY = 'FASAPAY',
    NETTELLER = 'NETTELLER',
    XPAYTHAI = 'XPAYTHAI',
    XPAYINDO = 'XPAYINDO'
}

export interface CreditCardPaymentDevice {
    payload?: CreditCardPayload;
    id?: string;
    payload_type?: string;
    account?: string;
}

export interface CreditCardPayload {
    crn?: string;
    card_label?: string;
    name?: string;
    type_lookup?: string;
    last_4_digits?: string;
    cvv?: string;
    expiry_date?: string;
    state?: boolean;
    is_verified_3D_secure?: boolean;
    is_verified_fraud_lab?: boolean;
    is_auto_approved?: boolean;
    created?: Date;
}

// Generated by https://quicktype.io

export interface SkrillPaymentDevice {
    payload?: SkrillPayload;
    id?: string;
    account?: string;
}

export interface SkrillPayload {
    skrill_user?: string;
    email?: string;
    state?: boolean;
    confirmed?: boolean;
    created?: string;
}

// Generated by https://quicktype.io

export interface BankAccountPaymentDevice {
    payload?: BankAccountPayload;
    id?: string;
    account?: string;
    payload_type?: PayloadType;
}

export interface BankAccountPayload {
    country?: string;
    label?: string;
    account_number?: string;
    account_swift_bic?: string;
    iban?: string;
    bank_name?: string;
    bank_address?: string;
    bank_telephone?: string;
    state?: boolean;
    confirmed?: boolean;
    created?: string;
    branch_code?: string;
    credit_card_last_digits?: string;
}

// Generated by https://quicktype.io

export interface NetellerPaymentDevice {
    payload?: NetellerPaymentDevicePayload;
    id?: string;
    account?: string;
}

export interface NetellerPaymentDevicePayload {
    netteller_user?: string;
    email?: string;
    state?: boolean;
    confirmed?: boolean;
    created?: string;
}

export interface BPayPaymentDevice {
    payload?: BPayPaymentDevicePayload;
    id?: string;
    account?: string;
}

export interface PaymentDevice {
    payload?: PaymentDevicePayload;
    id?: string;
    account?: string;
}

export interface BPayPaymentDevicePayload {
    wallet_id?: string;
    approx_balance?: null;
    state?: null;
    asm_user_id?: string;
    asm_wallet_id?: string;
    asm_user_bpay_crn?: null;
    asm_bank_account_id?: null;
    eig_user_id?: string;
}

export interface PaymentDevicePayload {
    wallet_id?: string;
    approx_balance?: null;
    state?: null;
    asm_user_id?: string;
    asm_wallet_id?: string;
    asm_user_bpay_crn?: null;
    asm_bank_account_id?: null;
    eig_user_id?: string;
}

// Generated by https://quicktype.io

export interface PoliPaymentDevice {
    payload?: PoliPaymentDevicePayload;
    id?: string;
    account?: string;
    payload_type?: PayloadType;
    users_linked?: PaymentDeviceUsersLinked[];
}

export interface PoliPaymentDevicePayload {
    account_number?: string;
    state?: boolean;
    confirmed?: boolean;
    created?: string;
}

// Generated by https://quicktype.io

export interface FasapayPaymentDevice {
    payload?: FasapayPaymentDevicePayload;
    id?: string;
    account?: string;
    payload_type?: PayloadType;
    users_linked?: PaymentDeviceUsersLinked[];
}

export interface FasapayPaymentDevicePayload {
    account_number?: string;
    state?: boolean;
    confirmed?: boolean;
    created?: string;
}

export interface PaymentPlatform {
    id?: string;
    friendly_name?: string;
    tenants_linked?: [
        {
            id?: string;
        }
    ];
    gateways_linked?: [
        {
            priority?: number;
            risk_level_lookup?: number;
            id?: string;
        }
    ];
}

export enum PayloadType {
    BANK_ACCOUNT = 'BKAC',
    BITWALLET = 'BITW',
    BPAY_WALLET = 'BPAY',
    CLIPPAY = 'CP',
    CREDIT_CARD = 'CRDC',
    ECHELON_THB = 'EPT',
    ECHELON_JYP = 'EPJ',
    EIG_PAGSMILE = 'EPS',
    FASAPAY = 'FSPY',
    LATIN_BANK_ACCOUNT = 'BKAL',
    NETELLER = 'NTLR',
    PAYPAL = 'PYPL',
    PHP = 'PHP',
    POLI = 'POLI',
    PMRB = 'PMRB',
    PMRT = 'PMRT',
    PMRU = 'PMRU',
    SKRILL = 'SKRL',
    UNION_PAY_CARD = 'UNPC',
    XPAY_THAI = 'XPTH',
    XPAY_INDO = 'XPID',
    XPAY_MYR = 'XPMA',
    XPAY_VND = 'XPVN'
}

export interface PaymentDeviceUsersLinked {
    id: string;
    email: string;
}
